const downloadFile = (fileBlob, fileName) => {
  const url = window.URL.createObjectURL(fileBlob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
};
export {
  downloadFile
};
//# sourceMappingURL=downloadFile.mjs.map
